import React from "react";
import style from "./index.module.scss";
import cn from "classnames";
import Loading from "../../shared/Loading/Loading";

const CustomButton = ({
  text = "",
  isWhite = false,
  isDisabled = false,
  isUnderline = false,
  isFall = false,
  isRedText = false,
  isBlueText = false,
  isGrayText = false,
  isBlackText = false,
  isMain = false,
  isMini = false,
  onClick = () => void 0,
  isLoading = false,
  prefixStart = "",
  ...rest
}) => {
  return (
    <button
      className={cn(style.buttonClass, {
        [style.btn_white]: isWhite,
        [style.disabled]: isDisabled,
        [style.btn_underline]: isUnderline,
        [style.btn_fall]: isFall,
        [style.btn_redText]: isRedText,
        [style.btn_blueText]: isBlueText,
        [style.btn_grayText]: isGrayText,
        [style.btn_blackText]: isBlackText,
        [style.btn_main]: isMain,
        [style.btn_mini]: isMini,
      })}
      onClick={onClick}
      {...rest}
    >
      {isLoading ? (
        <Loading inBlock marginBottom={0} />
      ) : (
        <>
          {prefixStart && (
            <div className={style.prefixStart}>{prefixStart}</div>
          )}
          {text}
        </>
      )}
    </button>
  );
};

export default CustomButton;
